import baseApiClient from '@cnd_fe/ky-client'

// API용 클라이언트 생성
const client = baseApiClient.extend({
  prefixUrl: import.meta.env.VITE_RES_ADMIN_SERVICE_URL
})

// API용 클라이언트 생성
const cmnClient = baseApiClient.extend({
  prefixUrl: import.meta.env.VITE_RES_CMN_SERVICE_URL
})

// API용 클라이언트 생성
const cmmnClient = baseApiClient.extend({
  prefixUrl: import.meta.env.VITE_RES_CMMN_SERVICE_URL
})

// 알람 메시지 전송용 클라이언트
const alarmClient = baseApiClient.extend({
  prefixUrl: import.meta.env.VITE_RES_ALARM_SERVICE_URL
})


/**
 * 사용중인 공통코드 목록 조회
 * @param {String} prntId - 상위코드ID
 * @returns {Promise<any>}
 */
export const fetchCmmCodeList = (prntId) => {
  try {
    const result = client.post('mng-cmmn/cmm-code-list', { json: { prntId: prntId } }).json()
    return result
  } catch (error) {
    throw error
  }
}

/**
 * 메뉴 목록 조회
 * @param {object} [payload] - 검색 파라미터
 * @returns {Promise<any>}
 */
export const getAllMenuList = async (payload = {}) => {
  try {
    const result = await client.post('mng-cmmn/menu-list', { json: payload }).json()
    return result
  } catch (error) {
    throw error
  }
}

/**
 * 기관정보 목록 조회
 * @param {object} [payload] - 검색 파라미터
 * @returns {Promise<any>}
 */
export const getMngInstList = async (payload = {}) => {
  try {
    const result = await client.post('mng-cmmn/mng-inst-list', { json: payload }).json()
    return result
  } catch (error) {
    throw error
  }
}

/**
 * 사용중인 기관정보 목록 조회
 * @param {object} [payload] - 검색 파라미터
 * @returns {Promise<any>}
 */
export const getUseInstList = async (payload = {}) => {
  try {
    const result = await client.post('mng-cmmn/use-inst-list', { json: payload }).json()
    return result
  } catch (error) {
    throw error
  }
}

const parseFilename = (contentDisposition) => {
  if (!contentDisposition) return 'download'
  const m = /filename\*=UTF-8''([^;]+)|filename="([^"]+)"/i.exec(contentDisposition)
  return decodeURIComponent(m?.[1] || m?.[2] || 'download')
}


/**
 * 파일 다운로드 호출
 * @param {string} atchFileId
 * @param {number} fileSn
 */
export const getFileDownload = async (atchFileId, fileSn) => {
  const res = await cmmnClient.get(`file-download/${atchFileId}/${fileSn}`)

  // 서버가 HTTP 200이지만 JSON 오류를 응답하는 경우 처리 (파일이 스토리지에 없는 경우 등)
  const contentType = res.headers.get('content-type') || ''
  if (contentType.includes('application/json')) {
    const errorData = await res.json()
    const message = errorData?.message || '파일 다운로드 중 오류가 발생하였습니다.'
    alert(message)
    return
  }

  const blob = await res.blob()
  const filename = parseFilename(res.headers.get('content-disposition'))

  const url = URL.createObjectURL(blob)
  const a = document.createElement('a')
  a.href = url
  a.download = filename
  document.body.appendChild(a)
  a.click()
  a.remove()
  URL.revokeObjectURL(url)
}

/**
 * 파일 Blob URL 생성 (PDF 뷰어 등에서 사용)
 * - BE 프록시 경유로 CORS 우회
 * @param {string} atchFileId
 * @param {number} fileSn
 * @returns {Promise<string>} blob URL
 */
export const getFileBlobUrl = async (atchFileId, fileSn) => {
  const res = await cmmnClient.get(`file-download/${atchFileId}/${fileSn}`)

  const contentType = res.headers.get('content-type') || ''
  if (contentType.includes('application/json')) {
    const errorData = await res.json()
    throw new Error(errorData?.message || '파일을 불러오는 중 오류가 발생하였습니다.')
  }

  const blob = await res.blob()
  return URL.createObjectURL(blob)
}


/**
 * 이미지 URL 생성
 * @param {string} atchFileId
 * @param {number} fileSn
 * @returns {Promise<string>} blob URL
 */
export const getImageUrl = async (atchFileId, fileSn) => {
  const res = await client.get(`mng-cmmn/file-download/${atchFileId}/${fileSn}`)

  const contentType = res.headers.get('content-type') || ''
  if (contentType.includes('application/json')) {
    const errorData = await res.json()
    throw new Error(errorData?.message || '이미지를 불러오는 중 오류가 발생하였습니다.')
  }

  const blob = await res.blob()
  return URL.createObjectURL(blob)
}


/**
 * 카테고리 목록 조회
 * @param {object} [payload] - 검색 파라미터
 * @returns {Promise<any>}
 */
export const getCommCateList = async (payload = {}) => {
  try {
    payload.instId = localStorage.getItem('SELECTED_INST') || ''
    const result = await cmnClient.post('cmm-cate-list', { json: payload }).json()
    return result
  } catch (error) {
    throw error
  }
}


/**
 * 카테고리 목록 트리 조회
 * @param {object} [payload] - 검색 파라미터
 * @returns {Promise<any>}
 */
export const getCommCateTreeList = async (payload = {}) => {
  try {
    payload.instId = localStorage.getItem('SELECTED_INST') || ''
    const result = await cmnClient.post('mng-cate-tree-list', { json: payload }).json()
    return result
  } catch (error) {
    throw error
  }
}


/**
 * 집계분류 목록 조회
 * @param {object} [payload] - 검색 파라미터
 * @returns {Promise<any>}
 */
export const getCommAggrCateList = async (payload = {}) => {
  try {
    payload.instId = localStorage.getItem('SELECTED_INST') || ''
    const result = await cmnClient.post('cmm-aggr-cate-list', { json: payload }).json()
    return result
  } catch (error) {
    throw error
  }
}

/**
 * 집계분류 목록 트리 조회
 * @param {object} [payload] - 검색 파라미터
 * @returns {Promise<any>}
 */
export const getCommAggrCateTreeList = async (payload = {}) => {
  try {
    payload.instId = localStorage.getItem('SELECTED_INST') || ''
    const result = await cmnClient.post('mng-aggr-cate-tree-list', { json: payload }).json()
    return result
  } catch (error) {
    throw error
  }
}

/**
 * 즐겨찾는 메뉴 목록 조회
 * @param {object} [payload] - 검색 파라미터
 * @returns {Promise<any>}
 */
export const getFvrtsMenuList = async (payload = {}) => {
  try {
    const result = await client.post('fvrts-menu-mng/fvrts-menu-list', { json: payload }).json()
    return result
  } catch (error) {
    throw error
  }
}


/**
 * 즐겨찾는 메뉴 처리(등록/삭제)
 * @param {object} [payload] - 검색 파라미터
 * @returns {Promise<any>}
 */
export const procFvrtsMenu = async (payload = {}) => {
  try {
    const result = await client.post('fvrts-menu-mng/fvrts-menu-proc', { json: payload }).json()
    return result
  } catch (error) {
    throw error
  }
}

/**
 * SMS 템플릿 목록 조회
 * @param {object} payload - { instId, searchText, pageIndex }
 * @returns {Promise<any>}
 */
export const getSmsTmpltList = async (payload = {}) => {
  try {
    payload.instId = payload.instId || localStorage.getItem('SELECTED_INST') || ''
    const result = await client.post('common/sms-tmplt-list', { json: payload }).json()
    return result
  } catch (error) {
    throw error
  }
}

/**
 * SMS 템플릿 처리 (등록/수정/삭제)
 * @param {object} payload - { processGbn, smsTmpltId, instId, tmpltTtl, tmpltCn }
 * @returns {Promise<any>}
 */
export const procSmsTmplt = async (payload = {}) => {
  try {
    payload.instId = payload.instId || localStorage.getItem('SELECTED_INST') || ''
    const result = await client.post('common/sms-tmplt-proc', { json: payload }).json()
    return result
  } catch (error) {
    throw error
  }
}

/**
 * 메시지 전송 (SMS/LMS/MMS/카카오톡)
 * @param {object} payload - 전송 파라미터
 * @returns {Promise<any>}
 */
export const sendMessage = async (payload = {}) => {
  try {
    payload.instId = payload.instId || localStorage.getItem('SELECTED_INST') || ''
    const result = await alarmClient.post('msgSend/sendMessage', { json: payload }).json()
    return result
  } catch (error) {
    throw error
  }
}

/**
 * 팝업 조회
 * @returns {Promise<any>}
 */
export const getPopupList = (payload) => {
  try {
    payload = { ...payload, domainId: import.meta.env.VITE_DOMAIN_ID }
    return cmmnClient.post(`user/popup-list`, { json: payload }).json()
  } catch (error) {
    throw error
  }


}

